export default __webpack_public_path__ + "static/media/wK.dc239b99.svg";